"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizeAgentDialog = CustomizeAgentDialog;
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _input = require("@design/ui/input");
var _label = require("@design/ui/label");
var _textarea = require("@design/ui/textarea");
var _useAgentSettings2 = require("./use-agent-settings");
var _jsxRuntime = require("react/jsx-runtime");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function CustomizeAgentDialog(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    onSaved = _ref.onSaved;
  var _useAgentSettings = (0, _useAgentSettings2.useAgentSettings)(open),
    agentName = _useAgentSettings.agentName,
    setAgentName = _useAgentSettings.setAgentName,
    instructions = _useAgentSettings.instructions,
    setInstructions = _useAgentSettings.setInstructions,
    isFormDisabled = _useAgentSettings.isFormDisabled,
    errorMessage = _useAgentSettings.errorMessage,
    saveAgentSettings = _useAgentSettings.saveAgentSettings;
  function handleSave(_x) {
    return _handleSave.apply(this, arguments);
  }
  function _handleSave() {
    _handleSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            event.preventDefault();
            _context.n = 1;
            return saveAgentSettings();
          case 1:
            if (_context.v) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            _context.n = 3;
            return onSaved();
          case 3:
            onOpenChange(false);
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleSave.apply(this, arguments);
  }
  var errorNotice = errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: "text-sm text-destructive",
    children: errorMessage
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.Dialog, {
    open: open,
    onOpenChange: onOpenChange,
    "data-sentry-element": "Dialog",
    "data-sentry-component": "CustomizeAgentDialog",
    "data-sentry-source-file": "customize-agent-dialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      className: "sm:max-w-lg",
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "customize-agent-dialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "customize-agent-dialog.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "customize-agent-dialog.tsx",
          children: "Customize agent"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSave,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-4",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
              htmlFor: "customize-agent-name",
              "data-sentry-element": "Label",
              "data-sentry-source-file": "customize-agent-dialog.tsx",
              children: "Agent name"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
              id: "customize-agent-name",
              value: agentName,
              placeholder: "Vera Engage",
              disabled: isFormDisabled,
              onChange: function onChange(event) {
                return setAgentName(event.target.value);
              },
              "data-sentry-element": "Input",
              "data-sentry-source-file": "customize-agent-dialog.tsx"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "text-sm text-muted-foreground",
              children: "This will be the author for redlines and comments in Word"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
              htmlFor: "customize-agent-instructions",
              "data-sentry-element": "Label",
              "data-sentry-source-file": "customize-agent-dialog.tsx",
              children: "Agent instructions"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
              id: "customize-agent-instructions",
              className: "min-h-24",
              value: instructions,
              placeholder: "Tell the agent who it is and how to behave, e.g. always respond to me in French",
              disabled: isFormDisabled,
              onChange: function onChange(event) {
                return setInstructions(event.target.value);
              },
              "data-sentry-element": "Textarea",
              "data-sentry-source-file": "customize-agent-dialog.tsx"
            })]
          }), errorNotice]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "customize-agent-dialog.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: function onClick() {
              return onOpenChange(false);
            },
            "data-sentry-element": "Button",
            "data-sentry-source-file": "customize-agent-dialog.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: isFormDisabled,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "customize-agent-dialog.tsx",
            children: "Save"
          })]
        })]
      })]
    })
  });
}